import { ReactNode } from 'react';
import { useClientFeatures } from 'hooks';
import { ClientFeature } from 'hooks/useClientFeatures';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface FeatureFlagGuardProps {
  featureFlag: ClientFeature;
  renderIfTrue: ReactNode;
  renderIfFalse: ReactNode;
}

export default function FeatureFlagGuard({ featureFlag, renderIfTrue, renderIfFalse }: FeatureFlagGuardProps) {
  const enabledFeatures = useSelector((state: RootState) => state.user.loggedUser.enabledFeatures);

  const { isFeatureEnabled } = useClientFeatures();
  const isFeatureFlagEnabled = isFeatureEnabled(featureFlag);

  if (enabledFeatures.length === 0) {
    return null;
  }

  return (
    <>
      {isFeatureFlagEnabled && renderIfTrue}
      {!isFeatureFlagEnabled && renderIfFalse}
    </>
  );
}
